import { Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'ax-datenschutz',
    standalone: true,
    imports: [],
    templateUrl: './datenschutz.component.html',
    styleUrl: '../nutzungsbedingungen/nutzungsbedingungen.component.scss',
})
export class DatenschutzComponent {
    protected readonly titleService = inject(Title);
    protected readonly metaService = inject(Meta);

    constructor() {
        this.titleService.setTitle('Datenschutzerklärung');
        this.metaService.addTag({
            name: 'description',
            content:
                'Lesen Sie unsere DSGVO-konforme Datenschutzerklärung. Ihre Daten sind uns wichtig. So gehen wir mit Ihren Daten um.',
        });
    }
}
